import { Component, OnInit } from '@angular/core';
import { NewsService } from '../../core/services/news.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './single-news.component.html',
  styleUrls: ['./single-news.component.scss'],
})
export class SingleNewsComponent implements OnInit {
  news = {
    title: '',
    createdAt: '2023-10-10T18:30:00.000Z',
    readTime: '',
    thumbnail: {
      url: '',
    },
    content: '',
    content1: [],
    author: '',
    link: '',
  };
  breadcrumbs: any[] = [];

  constructor(
    private newsService: NewsService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.newsService.getNewsById(id).then((resp) => {
        this.news = resp;
        this.initCrumbs();
      });
    }
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'News',
        route: '/admin/news',
      },
      {
        title: this.news.title,
      },
    ];
  }

  formatDate(date: any): any {
    const originalDate = new Date(date);
    const day = originalDate.getDate();
    const month = originalDate.toLocaleString('default', { month: 'long' });
    const year = originalDate.getFullYear();
    const formattedDay = this.getFormattedDay(day);

    return `${formattedDay} ${month} ${year}`;
  }

  getFormattedDay(day: number): string {
    if (day >= 11 && day <= 13) {
      return `${day}th`;
    }

    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }


  serializeToHTML(children: any[]): string {
    return children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let text = `<span>${this.escapeHTML(node.text)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<h1>${this.serializeToHTML(node.children)}</h1>`;
          case 'h2':
            return `<h2>${this.serializeToHTML(node.children)}</h2>`;
          case 'h3':
            return `<h3>${this.serializeToHTML(node.children)}</h3>`;
          case 'h4':
            return `<h4>${this.serializeToHTML(node.children)}</h4>`;
          case 'h5':
            return `<h5>${this.serializeToHTML(node.children)}</h5>`;
          case 'h6':
            return `<h6>${this.serializeToHTML(node.children)}</h6>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<a class="richLink" href="${this.escapeHTML(node.url)}">${this.serializeToHTML(
              node.children
            )}</a>`;

          default:
            return `<p class="font-[400]">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');
  }

  private escapeHTML(text: string): string {
    return text;
  }

}
